import React from "react";
import {ReactComponent as IconError} from "../../../assets/icons/error_rounded_white.svg"

import {Employee} from "../../../app/interfaces";
import { EMPLOYMENT_STATUS_TERMINATION_REQUEST } from "../../../utils/constants";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ContractTerminationContainer} from "./styles";

interface ContractTerminationProps {
    employee: Employee,
}

const ContractTermination = ({employee}: ContractTerminationProps) => {

    const {t} = useTranslation()
    const navigate = useNavigate()

    const {status} = employee;
    if (status !== EMPLOYMENT_STATUS_TERMINATION_REQUEST) {
        return null;
    }

    return <ContractTerminationContainer>
        <div className="message-wrapper">
            <div className="icon-box">
                <IconError/>
            </div>
            <div className="message">
                <h1>{status === EMPLOYMENT_STATUS_TERMINATION_REQUEST ? t('contract_termination_requested_title') : t('resignation_requested_title')}</h1>
                <p>{status === EMPLOYMENT_STATUS_TERMINATION_REQUEST ? t('contract_termination_requested_message') : t('resignation_requested_message')}</p>
                <button onClick={() => navigate(`/terminate_contract/${employee._id}`)}>{t('view_details')}</button>
            </div>
        </div>
    </ContractTerminationContainer>
}

export default ContractTermination;
